export const NEWBUILDING_COMPARE_ENABLED_CONFIG = 'Newbuilding.Compare.Frontend';
